export default __webpack_public_path__ + "static/media/layer6.2d598381.svg";